import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-guest-home',
  templateUrl: './guest-home.component.html',
  styleUrls: ['./guest-home.component.css']
})
export class GuestHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
